import {
    ActionIcon,
    Badge,
    Box,
    Button,
    Checkbox,
    Flex,
    Group,
    Stack,
    Text,
} from '@mantine/core';

import FiltersMultiSelect from '../../../../common/filtersMultiSelect/FiltersMultiSelect';
import { IconPlus } from '@tabler/icons-react';
import { NavLink } from 'react-router-dom';

const CampaignTableToolbar = ({
    filterOptions,
    activeFilters,
    onFilterChange,
    rightSection,
    actionButtons: ToolbarActions,
    showHidden,
    toggleShowHidden,
}) => {
    return (
        <>
            <Group
                ms={'xs'}
                gap={'xs'}
                align='flex-start'
                w={'100%'}>
                <FiltersMultiSelect
                    options={filterOptions}
                    onChange={onFilterChange}
                    value={activeFilters}
                />
            </Group>
            <Flex
                px={'md'}
                w={'100%'}
                align={'bottom'}
                justify={'flex-end'}>
                <NavLink to={'/campaigns/create'}>
                    <Button
                        size={'compact-xs'}
                        leftSection={
                            <IconPlus
                                style={{ width: '70%', height: '70%' }}
                                stroke={1.5}
                            />
                        }
                        styles={{
                            section: {
                                marginInlineEnd: 0,
                            },
                        }}>
                        New Campaign
                    </Button>
                </NavLink>
            </Flex>
            {rightSection}
        </>
    );
};
export default CampaignTableToolbar;
